import { numberToCurrency, numberToCurrencyAriaLabel } from '@lojinha/helpers'
import { t } from '../../dictionary'
import step1 from '../../assets/images/mgm-step1.png'
import step2 from '../../assets/images/mgm-step2.png'
import step3 from '../../assets/images/mgm-step3.png'

export const MGMStepsData = (reward?: number, discount?: number) => [
  {
    title: t.mgm.step1.title,
    description: `${t.mgm.step1.description_1} ${discount}% ${t.mgm.step1.description_2}`,
    ariaLabel: `${t.mgm.step1.description_1} ${discount} ${t.mgm.percent} ${t.mgm.step1.description_2}`,
    image: step1,
  },
  {
    title: t.mgm.step2.title,
    description: `${t.mgm.step2.description_1} ${numberToCurrency(reward)} ${
      t.mgm.step2.description_2
    }`,
    ariaLabel: `${t.mgm.step2.description_1} ${numberToCurrencyAriaLabel(
      reward
    )} ${t.mgm.step2.description_2}`,
    image: step2,
  },
  {
    title: t.mgm.step3.title,
    description: t.mgm.step3.description,
    image: step3,
  },
]
